import { getUiLocale } from "./locale";

/** "1 234,5" | "1234.50" → 1234.5; пусто/мусор → null. */
export function parseDecimal(text: string): number | null {
  const normalized = text.replace(/[\s ]/g, "").replace(",", ".");
  if (normalized === "" || normalized === "-" || normalized === ".") return null;
  const n = Number(normalized);
  return Number.isFinite(n) ? n : null;
}

export function formatDecimal(value: number | null, fractionDigits: number, locale = getUiLocale().numberLocale): string {
  if (value === null) return "";
  return new Intl.NumberFormat(locale, { minimumFractionDigits: 0, maximumFractionDigits: fractionDigits }).format(value);
}

/** Деньги хранятся в minor units (BIGINT): 45000 → «450 сом», 12345 → «123,45 сом». */
export function formatMoney(minor: number, currency = "KGS", locale = getUiLocale().numberLocale, fractionDigits = 2): string {
  const n = new Intl.NumberFormat(locale, { minimumFractionDigits: 0, maximumFractionDigits: fractionDigits }).format(minor / 10 ** fractionDigits);
  const sym = getUiLocale().currencySymbols[currency] ?? currency;
  return currency === "USD" ? `${sym}${n}` : `${n}\u00a0${sym}`;
}

/** Вес весовой позиции (количество в кг): меньше 1 кг — «450 г», иначе «1,25 кг». */
export function formatWeight(kg: number | string, locale = getUiLocale()): string {
  const g = Math.round(Number(kg) * 1000);
  return g < 1000 ? `${formatDecimal(g, 0, locale.numberLocale)} ${locale.text.grams}` : `${formatDecimal(g / 1000, 3, locale.numberLocale)} ${locale.text.kilograms}`;
}

/** Количество строки заказа: весовая — «450 г», штучная — «2». */
export const formatQty = (qty: number | string, weighted: boolean) => (weighted ? formatWeight(qty) : formatDecimal(Number(qty), 3));
